<p>assign-jeeves-defaults works!</p>
